// extracted by mini-css-extract-plugin
var _1 = "assets-js-ViewInvitation-components-Guestlist-Post-Likes-module__likes__IB89I";
export { _1 as "likes" }
